import type { SampleActivity } from '@omni/classes/activity/sample.activity.class';
import type { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';

/**
 * Consistent meeting ↔ activity linking for mandatory inline validation (and meeting structure),
 * so CRM / offline / brace-casing differences do not drop valid rows.
 */
export function normalizeActivityMeetingId(id: string | null | undefined): string {
  if (id == null || id === '') {
    return '';
  }
  return String(id).trim().toLowerCase().replace(/[{}]/g, '');
}

/** True if any candidate id matches the appointment's online id and/or offline id. */
export function isActivityLinkedToMeetingByIds(
  candidateIds: (string | null | undefined)[],
  meeting: { ID?: string; offlineMeetingId?: string }
): boolean {
  const m = [normalizeActivityMeetingId(meeting.ID), normalizeActivityMeetingId(meeting.offlineMeetingId)].filter(
    (k) => k.length > 0
  );
  if (!m.length) {
    return false;
  }
  const set = new Set(
    candidateIds.map(normalizeActivityMeetingId).filter((k) => k.length > 0)
  );
  return m.some((id) => set.has(id));
}

/**
 * Sample order ↔ meeting: keep logic here (not on SampleActivity) except the minimum constructor
 * mapping that copies `offlineMeetingId` into `appointmentID` when CRM id is missing.
 * Reads optional dynamic fields from the same shape some APIs persist.
 */
export function sampleOrderLinkedToMeeting(s: SampleActivity, meeting: AppointmentActivity): boolean {
  const anyS = s as any;
  return isActivityLinkedToMeetingByIds(
    [s.appointmentID, anyS.offlineMeetingId, anyS.indskr_appointmentid],
    meeting
  );
}